import React, { useEffect, useRef, useState, useMemo } from "react";
import "./index.less";
import { 
  addThumbsUp, 
  cancelThumbsUp, 
  addNoticeThumbsUp, 
  cancelNoticeThumbsUp, 
  addFaqThumbsUp, 
  cancelFaqThumbsUp,
  addFaqCollect,
  addNoticeCollect,
  addQuestionCollect,
  deleteQuestionComment,
  deleteFaqComment,
  cancelFavorite
} from "@/api/questions";
import { useGetLoginInfo } from "@/hooks/useGetLoginInfo";
import { Modal } from 'antd'

interface UpvoteEyesProps {
  // Define your props here
  data: {
    currentUserIsThumbsUp: boolean;
    thumbsUpCount: number;
    viewCount: number;
    [v:string]:any;
  };
  isEyes?:boolean
  isUpvote?: boolean;
  upvoteClick?: (cb:any) => void;
  upvoteType?: 'question' | 'answer' | 'comment' | 'notice';
  type?: 'faq' | 'notice' | 'feedback';
  showMore?: boolean;
  showCommentIcon?: boolean;
  showCollect?: boolean;
  showReport?: boolean;
  afterDelete?: (id: string) => void;
  showCommentInput?: () => void;
  handleReport?: (id: string) => void;
}

const UpvoteEyes: React.FC<UpvoteEyesProps> = (props) => {
  const [modal, contextHolder] = Modal.useModal();
  const { 
    data, 
    isEyes = true, 
    isUpvote = true, 
    upvoteType = 'question', 
    type = 'feedback', 
    showMore = false, 
    showCommentIcon = false,
    showCollect = false,
    showReport = false,
    handleReport,
    afterDelete,
    showCommentInput
  } = props;
  const { authorization, portalAuthorization, goLogin } = useGetLoginInfo();
  const isLogin = portalAuthorization && authorization;
  const typeMap = {
    'notice': {
      addThumbsUpApi: addNoticeThumbsUp,
      cancelThumbsUpApi: cancelNoticeThumbsUp,
      collectApi: addNoticeCollect,
      deleteCommentApi: () => '',
      collectType: 'NOTICE'
    },
    'feedback': {
      addThumbsUpApi: addThumbsUp,
      cancelThumbsUpApi: cancelThumbsUp,
      collectApi: addQuestionCollect,
      deleteCommentApi: deleteQuestionComment,
      collectType: 'UGC'
    },
    'faq': {
      addThumbsUpApi: addFaqThumbsUp,
      cancelThumbsUpApi: cancelFaqThumbsUp,
      collectApi: addFaqCollect,
      deleteCommentApi: deleteFaqComment,
      collectType: 'FAQ'
    }
  }
  const isTop = useMemo(() => {
    return data?.isTop || false;
  }, [data?.isTop]);
  const upvoteLoadingRef= useRef<any>(true);//点赞是否完毕
  const [isThumbsUp, setIsThumbsUp] = useState(data?.currentUserIsThumbsUp || false);
  const thumbsUpCount = useRef(data?.thumbsUpCount || 0);
  const timer=useRef<any>(null);
  const [isCollect, setIsCollect] = useState(data.currentUserIsFavorite);
  const upvoteClickHandler =async () => {
    if(timer.current!=null){
      return;
    }
    const isAdd=isThumbsUp;
    timer.current = setTimeout(async ()=>{
      try {
        if(isAdd){
          await cancelUpvoteHandle(data?.id )
         }else{
          await addUpvoteHandle(data?.id )
         }
     
         upvoteChangeHandle();
         
      } catch (error) {
        console.log("error", error);
      }
      timer.current = null;
    },200)
    
  }
  const upvoteChangeHandle=()=>{
    if(isThumbsUp){
      thumbsUpCount.current--;
      thumbsUpCount.current = Math.max(0,thumbsUpCount.current);

    }else{
      thumbsUpCount.current++;
    }
    setIsThumbsUp(!isThumbsUp);
  }
   /**
   * 点赞
   * @param id
   * @param type question（问题）， answer(答复)
   */
   const addUpvoteHandle = (id: any) => {
    const params = {
      sourceId: id,
      type: type === 'notice' ? 'notice' : upvoteType,
    };
    return new Promise((resolve, reject) => {
      typeMap[type].addThumbsUpApi(params).then((res: any) => {
        if (res.code === 200) {
          console.log("点赞成功");
          resolve(res);
        }else{
          
          reject(res);
          window.message.error(res.message);
        }
      }).catch((err: any) => {
        console.log("err", err);
        reject(err);
      }).finally(()=>{
        upvoteLoadingRef.current = true;
      });
    })
    
  };
  /**
   * 取消点赞
   * @param id
   */
  const cancelUpvoteHandle = (id: any) => {
    console.log("取消点赞");
    return new Promise((resolve, reject) => {
      typeMap[type].cancelThumbsUpApi(id).then((res: any) => {
        console.log("取消点赞成功", res);
        if (res.code === 200) {
          resolve(res);
        }else{
          reject(res);
        }
      }).catch((err: any) => {
        console.log("err", err);
        reject(err);
      }).finally(()=>{
        upvoteLoadingRef.current = true;
      });
    })
    
  };
  const handleCollect = () => {
    if (data.currentUserIsFavorite) {
      handleCancelCollect()
    } else {
      addCollect()
    }
  }
  const handleCancelCollect = async() => {
    modal.confirm({
      title: '提示',
      content: '确认取消收藏吗？',
      okText: '确认',
      cancelText: '取消',
      onOk: async() => {
        try {
          const cancelType = type === 'feedback' ? 'questAndAnswer' : type
          const res: any = await cancelFavorite(cancelType, data.id);
          if (res.code == 200) {
            window.message?.success('取消成功',2);
            setIsCollect(false);
          }
        } catch (error) {
          console.log("err", error);
        }
      },
    });
    
  }
  const addCollect = async() => {
    try {
      const res = await typeMap[type].collectApi({
        type: typeMap[type].collectType,
        sourceId: data.id
      })
      if (res.code == 200) {
        window.message?.success('收藏成功',2)
        setIsCollect(true);
      }
    } catch (error) {
      console.log("err", error);
    }
  }
  const handleComment = () => {
    if (!isLogin) {
      goLogin();
      return;
    }
    showCommentInput?.()
  }
  const handleDeleteComment = async () => {
    modal.confirm({
      title: '删除提示',
      content: '确认删除该评论吗？',
      okText: '确认',
      cancelText: '取消',
      onOk: async() => {
        try {
          const res: any = await typeMap[type].deleteCommentApi(data.id)
          if (res.code === 200) {
            window.message?.success('删除成功', 2)
            afterDelete && afterDelete(data.id)
          } else {
            window.message?.error(res.message, 2)
          }
        } catch (error) {
          console.log("err", error);
        }
      },
    });
  }
  useEffect(()=>{
    return ()=>{
      clearTimeout(timer.current);
      timer.current=null;
    }
  },[])
  return (
    <div className="upvote-box">
      {contextHolder}
      {
        isUpvote && <div
          className="upvote-box-upvote upvote-hover"
          style={{ cursor: "pointer" }}
          onClick={upvoteClickHandler}
        >
          <div className="flex-center">
            <img src={isThumbsUp ? require("@/assets/images/support/avport.png") : require("@/assets/images/support/no-avport.png")} alt="" />
          </div>

          {thumbsUpCount.current}
        </div>
      }
      {
        showCommentIcon && <div className="upvote-box-upvote" style={{ cursor: "pointer" }} onClick={handleComment}>
          <img src={require("@/assets/images/comment.png")} alt="" />
          <span>回复</span>
        </div>
      }
      {
        isEyes && <div className="upvote-box-upvote">
          <img src={require("@/assets/images/support/look.png")} alt="" />
          {data?.viewCount || 0}
        </div>
      }
      {
        isTop && <div className="upvote-box-upvote flex-center" style={{ cursor: 'default' }}>
          <img src={require("@/assets/images/top.png")} alt="" />
          <span>置顶</span>
        </div>
      }
      {
        showMore && ((showReport && !data?.isMine && data?.type === 'comment') || showCollect || (showCommentIcon && isLogin && data?.isMine)) && <div className="upvote-box-more">
          <div className="upvote-box-more-icon">
            <img src={require('@/assets/images/icon-more.png')} alt="" />
            <div className="popup-list">
              {showCollect && <div className="popup-item" onClick={handleCollect}>{isCollect ? '已收藏' : '收藏'}</div>}
              {showCommentIcon && isLogin && data?.isMine && <div className="popup-item" onClick={handleDeleteComment}>删除</div>}
              {showReport && !data?.isMine && data?.type === 'comment' && <div className="popup-item" onClick={() => handleReport?.(data.id)}>举报</div>}
            </div>
          </div>
        </div>
      }
    </div>
  );
};

export default React.memo(UpvoteEyes);
